import { AfterViewInit, Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {LoginService} from './core/components/login/login.service';
import {Globals} from './core/globals';
import { isPlatformBrowser } from "@angular/common";
import {ConfigService} from "./core/services/config.service";
import {CssService} from "./core/services/css.service";
import {CssPropertiesEnum} from "./core/models/css-properties.enum";
import {VHostService} from "./core/services/v-host.service";
import {WebSocketService, WebSocketTopics} from "./core/services/web-socket.service";
import {LandingPageService} from "./data/services/landing-page.service";
import {OrderTrackingService} from "./core/services/order-tracking.service";
import {GtmEnum} from "./core/models/gtm.enum";
import {BreadcrumbComponent} from "./core/components/breadcrumb/breadcrumb.component";
import {CssPropertyPipe} from "./core/pipes/css-property.pipe";
import {NavigationComponent} from "./webabo/navigation/navigation.component";

@Component({
  selector: 'app-hup-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    BreadcrumbComponent,
    CssPropertyPipe,
    RouterOutlet,
    NavigationComponent
],
  host: {ngSkipHydration: 'true'},
  standalone: true
})
export class AppComponent implements OnInit {
    private router = inject(Router);
    private loginService = inject(LoginService);
    private configService = inject(ConfigService);
    private cssService = inject(CssService);
    vHostService = inject(VHostService);
    private websocketService = inject(WebSocketService);
    private route = inject(ActivatedRoute);
    private landingPageService = inject(LandingPageService);
    private orderTrackingService = inject(OrderTrackingService);
    private platformId = inject<Object>(PLATFORM_ID);

    title = 'webabo';
    useLandingPage = Globals.USE_LANDING_PAGE;
    useBreadCrumb = Globals.USE_BREADCRUMB;
    horizontalNavigation = true;
    cssPropertiesEnum = CssPropertiesEnum;

    hideNavigation = false;
    showNavigation: boolean = true;

    constructor() {
        const loginService = this.loginService;
        const platformId = this.platformId;

        if (isPlatformBrowser(platformId) && window['dataLayer']) {
          dataLayer = window['dataLayer'];
        }
        this.route.queryParams.subscribe(params => {
            this.hideNavigation = !!params['hideNavigation'];
        });

        // Layout-Konfiguration aktiv laden statt nur den Cache zu lesen: app.component ist der
        // Layout-Host und wird auf jeder Route benötigt. Routen ohne defaultConfig-Resolver
        // (z. B. /offer, /offer/list) hätten den Cache sonst nie befüllt -> Content verschoben.
        this.loadLayoutConfig();


        this.router.events.forEach(item => {
            if (item instanceof NavigationEnd) {
                this.horizontalNavigation = this.configService.getConfig('horizontalNavigation')?.asBoolean()
                    ?? this.horizontalNavigation;

                const gtmTag = {
                    event: 'page',
                    pageName: item.url
                };
                this.orderTrackingService?.pushEvent(GtmEnum.SITE_NAVIGATION, gtmTag);
            }
        });

        loginService.isChildUser$.subscribe(childUserState => {
          if (childUserState) {
            this.router.navigateByUrl('/child-user-info', {skipLocationChange: true});
          }
        });

        // Styles so früh wie möglich setzen für SSR
        this.cssService?.setStyles()?.subscribe();
        this.vHostService.vHost?.css?.forEach(cssStyle => {
            if (cssStyle && cssStyle.key === 'css.customCss') {
                this.cssService.appendCss(cssStyle.value);
            }
        });
    }

    private loadLayoutConfig(): void {
        this.configService.loadConfig('horizontalNavigation').subscribe(config => {
            this.horizontalNavigation = config?.asBoolean() ?? this.horizontalNavigation;
        });
        this.configService.loadConfig('removeNavigation').subscribe(config => {
            this.hideNavigation = config?.asBoolean() ?? this.hideNavigation;
        });
    }

    ngOnInit(): void {
      /*
      this.router?.events?.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            if (isPlatformBrowser(this.platformId)) {
                window.scrollTo(0, 0);
            }
        });
*/
        this.loginService.autoLogin();
        this.loginService.checkStatus();
        this.orderTrackingService.generateTransactionId();

        this.websocketService.getObservable(WebSocketTopics.configChanged).subscribe(data => {
            this.configService.clearConfig();
            this.landingPageService.resetData();
        });

        this.websocketService.getObservable(WebSocketTopics.clearCache).subscribe(data => {
            this.loginService.logout();
        });
    }
}
